import { useContext, useEffect, useRef } from "react";

import { AmplitudeEvents } from "../../constants/amplitude";
import { ConsentModeContext } from "../../contexts/ConsentModeContext";

import { useAmplitude } from "./useAmplitude";

export const useLogVisitPageAmplitudeEvent = ({
  event = AmplitudeEvents.PageViewed,
  payload,
  loading = false,
  onceKey,
}: {
  event?: AmplitudeEvents;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: Record<string, any>;
  loading?: boolean;
  onceKey?: string;
}) => {
  const { logAmplitudeEvent, isAmplitudeLoading } = useAmplitude();
  const { hasFunctionalityConsentMode } = useContext(ConsentModeContext);
  const loggedKeyRef = useRef<{ onceKey: string | undefined } | null>(null);

  useEffect(() => {
    const hasLogged = loggedKeyRef.current !== null && loggedKeyRef.current.onceKey === onceKey;
    if (hasLogged || loading || isAmplitudeLoading || !hasFunctionalityConsentMode) {
      return;
    }
    loggedKeyRef.current = { onceKey };
    logAmplitudeEvent(event, payload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, isAmplitudeLoading, hasFunctionalityConsentMode, onceKey]);
};
